import type { IconData } from '@stacksjs/iconify-core'

export const iHospital: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.13 34.78v27.8H7.18V.592h12.95v23.483h24.173V.592h12.95V62.58h-12.95v-27.8z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iHospital
